export default "__VITE_ASSET__BJxvzird__"